export interface ColorVariant {
  _id?: string;
  id?: string;
  name: string;
  colorCode?: string;
  image?: string;
  images?: string[];
  price?: number;
  originalPrice?: number;
  amazonLink?: string;
  flipkartLink?: string;
  isDefault?: boolean;
}

export interface Product {
  id: string;
  title: string;
  description: string;
  shortDescription?: string;
  image: string;
  price: number;
  originalPrice?: number;
  category: string;
  amazonLink?: string;
  flipkartLink?: string;
  videoUrl?: string;
  slug?: string;
  specifications?: {
    [key: string]: string;
  };
  features?: string[];
  highlights?: string[];
  rating?: number;
  reviews?: number;
  featured?: boolean;
  sellOnSite?: boolean;
  colorVariants?: ColorVariant[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CartItem {
  product: Product;
  quantity: number;
  selectedColor?: string;
  selectedColorVariant?: ColorVariant;
}

export const categories = [
  { id: 'speakers', name: 'Speakers', icon: '🔊' },
  { id: 'chargers', name: 'Chargers', icon: '🔌' },
  { id: 'headphones', name: 'Headphones', icon: '🎧' },
  { id: 'accessories', name: 'Accessories', icon: '📱' },
  { id: 'powerbanks', name: 'Power Banks', icon: '🔋' },
  { id: 'cables', name: 'Cables', icon: '🔗' },
];

export const sampleProducts: Product[] = [
  {
    id: '1',
    title: 'Portronics SoundDrum 1 Wireless Bluetooth Speaker',
    description: 'Experience powerful sound with the Portronics SoundDrum 1. This wireless Bluetooth speaker delivers crystal-clear audio with deep bass and excellent clarity. Perfect for parties, outdoor adventures, or simply enjoying music at home.',
    shortDescription: 'Wireless Bluetooth speaker with powerful sound and deep bass',
    image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=500&h=500&fit=crop',
    price: 1299,
    originalPrice: 1999,
    category: 'speakers',
    amazonLink: 'https://amazon.in/dp/B08XYZ123',
    flipkartLink: 'https://flipkart.com/p/portronics-sounddrum-1',
    specifications: {
      'Connectivity': 'Bluetooth 5.0',
      'Battery Life': '8-10 hours',
      'Range': '10 meters',
      'Charging': 'Micro USB',
      'Weight': '350g',
      'Dimensions': '15 x 6 x 6 cm'
    },
    colorVariants: [
      {
        name: 'Carbon Black',
        colorCode: '#1a1a1a',
        image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=500&h=500&fit=crop',
        isDefault: true,
      },
      {
        name: 'Teal Blue',
        colorCode: '#1e5e72',
        image: 'https://images.unsplash.com/photo-1545454675-3531b543be5d?w=500&h=500&fit=crop',
      },
      {
        name: 'Crimson Red',
        colorCode: '#a11e26',
        image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&h=500&fit=crop',
      },
      {
        name: 'Deep Purple',
        colorCode: '#3b1c28',
        image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=500&h=500&fit=crop',
      },
    ],
    features: [
      'Wireless Bluetooth connectivity',
      'Deep bass technology',
      '8-10 hours playtime',
      'Compact and portable design',
      'Built-in microphone for calls'
    ],
    rating: 4.3,
    reviews: 1247
  },
  {
    id: '2',
    title: 'Portronics POR-845 20W Fast Charger',
    description: 'Charge your devices at lightning speed with the Portronics POR-845 20W Fast Charger. Compatible with all smartphones and tablets, this charger provides safe and efficient charging with advanced safety features.',
    shortDescription: '20W fast charger with advanced safety features',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=500&fit=crop',
    price: 899,
    originalPrice: 1299,
    category: 'chargers',
    amazonLink: 'https://amazon.in/dp/B09ABC456',
    flipkartLink: 'https://flipkart.com/p/portronics-por-845-charger',
    specifications: {
      'Output Power': '20W',
      'Input': '100-240V AC',
      'Output': '5V/3A, 9V/2.22A',
      'Compatibility': 'iPhone, Android, iPad',
      'Safety': 'Over-current, Over-voltage protection',
      'Cable Length': '1 meter'
    },
    features: [
      '20W fast charging',
      'Universal compatibility',
      'Advanced safety protection',
      'Compact design',
      'LED charging indicator'
    ],
    rating: 4.5,
    reviews: 892
  },
  {
    id: '3',
    title: 'Portronics POR-1315 Wireless Bluetooth Headphones',
    description: 'Immerse yourself in superior audio quality with the Portronics POR-1315 Wireless Bluetooth Headphones. Featuring noise cancellation, comfortable ear cups, and long-lasting battery life for the ultimate listening experience.',
    shortDescription: 'Wireless Bluetooth headphones with noise cancellation',
    image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&h=500&fit=crop',
    price: 2499,
    originalPrice: 3499,
    category: 'headphones',
    amazonLink: 'https://amazon.in/dp/B10DEF789',
    flipkartLink: 'https://flipkart.com/p/portronics-por-1315-headphones',
    specifications: {
      'Connectivity': 'Bluetooth 5.0',
      'Battery Life': '25 hours',
      'Charging Time': '2 hours',
      'Frequency Response': '20Hz - 20kHz',
      'Impedance': '32 ohms',
      'Weight': '250g'
    },
    features: [
      'Active noise cancellation',
      '25 hours battery life',
      'Quick charge technology',
      'Comfortable over-ear design',
      'Built-in microphone'
    ],
    rating: 4.2,
    reviews: 634
  },
  {
    id: '4',
    title: 'Portronics POR-1560 20000mAh Power Bank',
    description: 'Never run out of power with the Portronics POR-1560 20000mAh Power Bank. This high-capacity power bank features fast charging, multiple ports, and LED indicators to keep all your devices charged on the go.',
    shortDescription: '20000mAh power bank with fast charging and multiple ports',
    image: 'https://images.unsplash.com/photo-1609592807902-1a4b8a4b8a4b?w=500&h=500&fit=crop',
    price: 1899,
    originalPrice: 2499,
    category: 'powerbanks',
    amazonLink: 'https://amazon.in/dp/B11GHI012',
    flipkartLink: 'https://flipkart.com/p/portronics-por-1560-powerbank',
    specifications: {
      'Capacity': '20000mAh',
      'Output Ports': '2 USB-A, 1 USB-C',
      'Input': 'Micro USB, USB-C',
      'Fast Charge': '18W',
      'Weight': '400g',
      'Dimensions': '15 x 7 x 2 cm'
    },
    features: [
      '20000mAh high capacity',
      'Fast charging technology',
      'Multiple output ports',
      'LED power indicator',
      'Compact and lightweight'
    ],
    rating: 4.4,
    reviews: 1156
  },
  {
    id: '5',
    title: 'Portronics POR-789 USB-C to USB-C Cable',
    description: 'High-quality USB-C to USB-C cable for fast data transfer and charging. Made with durable materials and gold-plated connectors for reliable performance and longevity.',
    shortDescription: 'High-quality USB-C to USB-C cable for fast charging',
    image: 'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=500&h=500&fit=crop',
    price: 299,
    originalPrice: 499,
    category: 'cables',
    amazonLink: 'https://amazon.in/dp/B12JKL345',
    flipkartLink: 'https://flipkart.com/p/portronics-por-789-cable',
    specifications: {
      'Length': '1 meter',
      'Connector': 'USB-C to USB-C',
      'Data Transfer': 'Up to 480Mbps',
      'Charging': 'Up to 3A',
      'Material': 'Nylon braided',
      'Connector Type': 'Gold-plated'
    },
    features: [
      'Fast data transfer',
      'High-speed charging',
      'Durable nylon braiding',
      'Gold-plated connectors',
      'Universal compatibility'
    ],
    rating: 4.1,
    reviews: 423
  },
  {
    id: '6',
    title: 'Portronics POR-456 Phone Stand with Wireless Charging',
    description: 'The perfect desk companion for your smartphone. This adjustable phone stand features wireless charging capability, multiple viewing angles, and a sleek design that complements any workspace.',
    shortDescription: 'Adjustable phone stand with wireless charging capability',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=500&h=500&fit=crop',
    price: 1299,
    originalPrice: 1799,
    category: 'accessories',
    amazonLink: 'https://amazon.in/dp/B13MNO678',
    flipkartLink: 'https://flipkart.com/p/portronics-por-456-stand',
    specifications: {
      'Charging': 'Wireless Qi charging',
      'Power': '10W',
      'Compatibility': 'iPhone, Samsung, Google Pixel',
      'Material': 'Aluminum + ABS',
      'Adjustable': 'Multiple angles',
      'Weight': '200g'
    },
    features: [
      'Wireless charging',
      'Adjustable viewing angles',
      'Premium aluminum build',
      'Universal compatibility',
      'LED charging indicator'
    ],
    rating: 4.6,
    reviews: 789
  }
];
